(function() {
  'use strict';

  angular
    .module('webAgro1App')
    .controller('PropriedadeHistoricoCtrl', PropriedadeHistoricoController);

  PropriedadeHistoricoController.$inject = [
    '$scope',
    'HistoricosService',
    '$uibModal',
    '$filter'
  ];

  function PropriedadeHistoricoController($scope, HistoricosService, $uibModal, $filter) {
    const vm = this;

    //////////////////////////////////////////
    // Controller data
    vm.filters = {
      search: '',
      tipos: [],
      usuarios: [],
      culturas: []
    };
    vm.filtersTitles = {
      tipos: null,
      usuarios: null,
      culturas: null
    };
    vm.hasFilters = false;
    vm.unreadHistories = [];

    //////////////////////////////////////////
    // Bindable functions
    vm.scrollToTop = scrollToTop;
    vm.showFilters = showFilters;
    vm.checkForFilters = checkForFilters;
    vm.clearFilters = clearFilters;

    //////////////////////////////////////////
    // Function declaration

    function scrollToTop() {
      $('.sidebar-historico').animate({
        scrollTop: 0
      }, {
        queue: false
      });
    }

    function loadHistoricoPropriedade() {
      return HistoricosService.getHistoricos($scope.$root.currentPropriedade.id)
        .then(({ data: { historicos } }) => {
          vm.unreadHistories = historicos.slice(0, -10);
        })
        .then(() => confirmReadHistory());
    }

    function confirmReadHistory() {
      $scope.$emit('clearNotifications');
      return HistoricosService.confirmRead($scope.$root.currentPropriedade.id);
    }

    function showFilters() {
      const newScope = $scope.$root.$new();
      newScope.filters = {
        tipos: vm.filters.tipos.slice(),
        culturas: vm.filters.culturas.slice(),
        usuarios: vm.filters.usuarios.slice()
      };
      newScope.data = $scope.sharedData;
      $uibModal.open({
        templateUrl: 'views/propriedade/historico/filters.html',
        scope: newScope
      }).result.then((result) => {
        if (result) {
          vm.filters = {
            search: vm.filters.search,
            ...result
          };
          regenerateDescriptions();
        }
      });
    }

    function regenerateDescriptions() {
      const { tipos, usuarios, culturas } = vm.filters;
      const capitalize = $filter('capitalize');
      vm.filtersTitles = {
        tipos: tipos.length ? _.flatMap(tipos, 'descricao').join(', ') : 'Todos',
        usuarios: usuarios.length ? _.flatMap(usuarios, 'descricao').map(capitalize).join(', ') : 'Todos',
        culturas: culturas.length ? _.flatMap(culturas, 'descricao').map(capitalize).join(', ') : 'Todas'
      };
      checkForFilters();
    }

    function checkForFilters() {
      vm.hasFilters = Object.values(vm.filters).some((filter) => filter instanceof Array && !!filter.length);
    }

    function clearFilters() {
      Object.keys(vm.filters).forEach((key) => {
        if (typeof vm.filters[key] === 'string') {
          vm.filters[key] = '';
        } else {
          vm.filters[key] = [];
        }
      });
      regenerateDescriptions();
    }

    //////////////////////////////////////////
    // Controller logic

    if ($scope.hasUnreadNotifications) {
      loadHistoricoPropriedade();
    }
    regenerateDescriptions();
  }
}());
